import type { SVGProps } from 'react';
import { ICON_PATHS } from './icon-paths.generated';

export type IconName = keyof typeof ICON_PATHS;

interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  size?: number;
}

/**
 * Иконки – line-style SVG, перенесены из макета «Компас». Исходники (по одному
 * SVG-файлу на иконку) – в src/icons/svg/, отсюда собирается icon-paths.generated.tsx
 * (`npm run icons:build`). Чтобы добавить иконку – положить .svg в src/icons/svg/
 * и перегенерировать; руками icon-paths.generated.tsx не редактировать.
 */
export function Icon({ name, size = 18, ...rest }: IconProps) {
  const { fill, strokeWidth, children } = ICON_PATHS[name];
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      {children}
    </svg>
  );
}
